<template>
  <div class="radio-button">
    <input
      type="radio"
      :checked="checked"
      :disabled="disabled"
      :id="id"
      :name="name"
      :value="value"
      @change="onChange"
      />
    <label :for="id" :style="backgroundColor">
      <icon class="icon" :icon="icon" size="medium" />
      <span><slot /></span>
      <icon class="icon status" size="tiny" :icon="statusIcon" />
    </label>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  props: {
    name: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: [Number, String],
      required: false,
      default: null
    },
    modelValue: {
      default: false
    },
    icon: {
      type: String,
      default: 'soho'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: null
    }
  },
  computed: {
    backgroundColor () {
      return this.color && this.checked && this.disabled ? { background: this.color } : null
    },
    checked () {
      return this.modelValue === this.value
    },
    statusIcon () {
      if (!this.checked && this.disabled) {
        return 'disabled'
      }
      return 'checkmark'
    }
  },

  data () {
    return {
      id: null
    }
  },

  methods: {
    onChange () {
      this.$emit('input', this.checked ? '' : this.value)
    }
  },

  model: {
    prop: 'modelValue',
    event: 'input'
  },

  mounted () {
    this.id = `radio-button-${uuid()}`
  }
}
</script>

<style lang="scss">
  .radio-button {
    width: 100%;
    padding-bottom: $space-030;

    input {
      @include visually-hidden();
    }
  }

  .radio-button {

    .icon {
      @include transition-fast;
    }

    label {
      @include border-small();
      @include label-xx-sml;
      @include deprecated-f-color-dark;
      padding: $d-xx-small;
      display: flex;
      align-items: center;
      background: $color-white;
      cursor: pointer;
      @include transition-fast;
      position: relative;

      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border: 1px solid rgba($color-white, 0);
        @include transition-fast;
        opacity: 0;
        pointer-events: none;
        visibility: hidden;
      }

      .icon:first-child {
        margin-right: $d-xx-small;
        min-width: $d-med-small;
      }

      span {
        flex-grow: 1;
      }

      .icon.status {
        height: $d-x-small;
        width: $d-x-small;
        opacity: 0;
        pointer-events: none;
        visibility: hidden;
        transform: scale(0);
      }
    }

    input:checked + label {
      @include border-medium();

      .icon.status {
        opacity: 1;
        visibility: visible;
        transform: scale(1);
      }
    }

    input[disabled]:not(:checked) + label {
      cursor: not-allowed;
      background-color: $deprecated-grey-x-light;

      .icon.status {
        display: block;
      }
    }

    input[disabled]:checked + label {
      cursor: not-allowed;
      box-shadow: none;
      @include f-color-white;

      .icon {
        filter: invert(1)
      }

      .icon.checkmark {
        opacity: 1;
        visibility: visible;
        transform: scale(1);
      }
    }

    input:focus {
      & + label:after {
        opacity: 1;
        visibility: visible;
        pointer-events: none;
        border: $line-focus;
      }
    }
    input:checked:focus {
      & + label {
        box-shadow: none;
      }
    }
  }

  .schedule .radio-button {
    .icon:first-of-type {
      display: none;
    }
    label {
      padding: $d-x-small $d-x-small $d-x-small $d-small;
    }
  }
</style>
